export enum ProductType {
  locker,
  home,
}
